module.exports = __webpack_public_path__ + "img/car_work.bae42327.png";